import type { ReviewStatsResponseRatingDistribution } from './reviewStatsResponseRatingDistribution';
import type { ReviewStatsResponseTagsItem } from './reviewStatsResponseTagsItem';

/**
 * 리뷰 통계 응답
 */
export interface ReviewStatsResponse {
  /** 평균 평점 */
  averageRating: number;
  /** 평점별 분포 */
  ratingDistribution: ReviewStatsResponseRatingDistribution;
  /** 인기 태그 */
  tags?: ReviewStatsResponseTagsItem[];
  /** 총 리뷰 수 */
  totalReviews: number;
}
